/*! @azure/msal-common v15.9.0 2025-07-30 */
'use strict';
/* eslint-disable header/header */
const name = "@azure/msal-common";
const version = "15.9.0";

export { name, version };
//# sourceMappingURL=packageMetadata.mjs.map
